module.exports = "/_next/static/images/OptimizeSyncRuns@2x-8177b17419562a137eaed48f76c9f151.webp";